import React, { useEffect, useState } from 'react';
import { FIRST_KICKOFF_UTC, getNow } from '../utils/lockUtils';
import './CountdownBar.css';

function formatDuration(ms) {
  if (ms <= 0) return '0s';
  const totalSec = Math.floor(ms / 1000);
  const days    = Math.floor(totalSec / 86400);
  const hours   = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  if (days > 0)  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
  return `${minutes}m ${seconds}s`;
}

export default function CountdownBar() {
  const [remaining, setRemaining] = useState(FIRST_KICKOFF_UTC.getTime() - getNow());

  useEffect(() => {
    if (FIRST_KICKOFF_UTC.getTime() <= getNow()) return;
    const id = setInterval(() => {
      const ms = FIRST_KICKOFF_UTC.getTime() - getNow();
      setRemaining(ms);
      if (ms <= 0) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, []);

  if (remaining <= 0) return null;

  return (
    <div className="countdown-bar">
      <span className="countdown-bar-label">Picks lock in</span>
      <span className="countdown-bar-time">{formatDuration(remaining)}</span>
    </div>
  );
}
